<template>
  <div class="mx-auto">
    <TitleWrapper
      :filter-option="false"
      title="NOTIFICATION_PREFERENCES"
      tooltip-title="NOTIFICATION_PREFERENCES"
      :display-breadcrumb="true"
    />
    <div v-if="isLoading && !notificationPreferencesList.length" class="mt-28">
      <Loader :content="true" />
    </div>
    <TableWrapper v-else table-height="h-auto">
      <THead>
        <TRHead>
          <TH
            v-for="(head, index) in tableHeads"
            :key="index"
            v-permission="getHeaderPermission(index)"
          >
            {{ head }}
          </TH>
        </TRHead>
      </THead>
      <TBody>
        <TRBody v-for="(preference, index) in notificationPreferencesList" :key="index">
          <TD v-i18n="leftBar">{{ preference?.feature_name }}</TD>
          <TD>
            <ToggleButton
              v-model="preference.notifications_enabled"
              class="mt-1"
              :is-status-hide="true"
              @change="toggleNotificationPreference(preference.feature_name, index)"
            />
          </TD>
          <TD v-permission="reportPermissions">
            <template v-if="!isEmpty(preference?.reports)">
              <ToggleButton
                v-model="preference.reports[getReportsKey(preference.reports, 'MONTHLY')]"
                class="mt-1"
                :is-status-hide="true"
                @change="
                  toggleNotificationPreference(
                    preference?.feature_name,
                    index,
                    getReportsKey(preference.reports, 'MONTHLY'),
                  )
                "
              />
            </template>
            <template v-else>
              {{ GENERAL_CONSTANTS.NOT_APPLICABLE }}
            </template>
          </TD>
          <TD v-permission="reportPermissions">
            <template v-if="!isEmpty(preference?.reports)">
              <ToggleButton
                v-model="preference.reports[getReportsKey(preference.reports, 'WEEKLY')]"
                class="mt-1"
                :is-status-hide="true"
                @change="
                  toggleNotificationPreference(
                    preference?.feature_name,
                    index,
                    getReportsKey(preference.reports, 'WEEKLY'),
                  )
                "
              />
            </template>
            <template v-else>
              {{ GENERAL_CONSTANTS.NOT_APPLICABLE }}
            </template>
          </TD>
        </TRBody>
      </TBody>
    </TableWrapper>
  </div>
</template>

<script>
import {
  TableWrapper,
  THead,
  TRHead,
  TH,
  TBody,
  TRBody,
  TD,
} from '@src/components/UiElements/TableElements/index.js'
import TitleWrapper from '@components/TitleWrapper.vue'
import ToggleButton from '@src/components/BaseComponent/toggleButton.vue'
import { mapActions, mapState } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import GENERAL_CONSTANTS from '@src/constants/general-constants.js'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import isEmpty from 'lodash/isEmpty'
export default {
  name: 'NotificationPreferencesView',
  components: {
    TitleWrapper,
    TableWrapper,
    THead,
    TRHead,
    TH,
    TBody,
    TRBody,
    TD,
    ToggleButton,
    Loader,
  },
  data() {
    return {
      GENERAL_CONSTANTS,
      leftBar: 'leftBar',
      tableHeads: ['Feature Name', 'Notification Status', 'Monthly Report', 'Weekly Report'],
      reportActions: {
        MONTHLY: 'ACTION_STUDENT_MONTHLY_REPORT',
        WEEKLY: 'ACTION_STUDENT_WEEKLY_REPORT',
      },
      notificationPreferencesList: [],
      isLoading: false,
    }
  },
  computed: {
    ...mapState('layout', ['currentCampusScope']),

    reportPermissions() {
      return { roles: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN] }
    },
  },

  watch: {
    currentCampusScope() {
      this.initializeNotificationPreferencesList()
    },
  },

  mounted() {
    this.initializeNotificationPreferencesList()
  },

  methods: {
    isEmpty,
    ...mapActions('layout', ['setUserNotificationPreferences', 'getUserNotificationPreferences']),
    toggleNotificationPreference(preference, index, reportAction = null) {
      const payload = reportAction
        ? {
            feature_name: preference,
            report_name: reportAction,
          }
        : {
            feature_name: preference,
          }

      this.setUserNotificationPreferences(payload).catch(() => {
        this.initializeNotificationPreferencesList()
      })
    },
    async initializeNotificationPreferencesList() {
      this.isLoading = true

      await this.getUserNotificationPreferences()
        .then((response) => {
          const responseDataCandidate = response?.data?.data ?? response?.data
          this.notificationPreferencesList = responseDataCandidate
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getReportsKey(reports, keyType = 'MONTHLY') {
      if (!reports || typeof reports !== 'object') return null

      const reportKey = Object.keys(reports).find((report) => report.includes(keyType))
      return reportKey || null
    },
    getHeaderPermission(index) {
      // Index 2 = Monthly Report, Index 3 = Weekly Report
      return index >= 2 ? this.reportPermissions : null
    },
  },
}
</script>
